import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var UnknownError = function UnknownError(status, data) {
    _classCallCheck(this, UnknownError);

    this.data = data;
    this.status = status;
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/unknown.js
// module id = ./src/abstractions/errors/unknown.js
// module chunks = 34